/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Status_Tracking_Code_CreatedInputs */

const tr_geliver_status_tracking_code_created = /** @type {(inputs: Geliver_Status_Tracking_Code_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiket hazır`)
};

const en_geliver_status_tracking_code_created = /** @type {(inputs: Geliver_Status_Tracking_Code_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label ready`)
};

const de_geliver_status_tracking_code_created = /** @type {(inputs: Geliver_Status_Tracking_Code_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etikett bereit`)
};

const ru_geliver_status_tracking_code_created = /** @type {(inputs: Geliver_Status_Tracking_Code_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этикетка готова`)
};

/**
* | output |
* | --- |
* | "Label ready" |
*
* @param {Geliver_Status_Tracking_Code_CreatedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_status_tracking_code_created = /** @type {((inputs?: Geliver_Status_Tracking_Code_CreatedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Status_Tracking_Code_CreatedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_status_tracking_code_created(inputs)
	if (locale === "de") return de_geliver_status_tracking_code_created(inputs)
	if (locale === "ru") return ru_geliver_status_tracking_code_created(inputs)
	return tr_geliver_status_tracking_code_created(inputs)
});